import React from 'react';
import Hero from '../components/Hero';
import AppShowcase from '../components/AppShowcase';

const Home = () => {
    return (
        <>
            <Hero />
            <AppShowcase />
        </>
    );
};

export default Home;
